var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-box"},[_c('div',{staticClass:"content-name"},[_c('h2',{staticClass:"dp-ib"},[_vm._v("해피콜관리"+_vm._s(_vm.tabName))])]),_c('tabs',{attrs:{"tab":_vm.tab,"active-btn":_vm.active},on:{"changeTab":_vm.changeTab}}),_c(_vm.viewer,{ref:"cmpTab",tag:"component",attrs:{"custParam":_vm.custParam}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }